import { Link } from 'react-router';
import { AlertCircle, Wallet } from 'lucide-react';
import { useBillingSummary } from '@/hooks/use-billing-summary';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

const formatCredits = (value: number) => value.toLocaleString();

export function CreditBalanceIndicator() {
	const { summary, loading, error, isAvailable, walletLabel } =
		useBillingSummary();

	if (!isAvailable) return null;

	const balance = summary.balance.balance;
	const isLow = balance <= 0;

	return (
		<TooltipProvider delayDuration={150}>
			<Tooltip>
				<TooltipTrigger asChild>
					<Link
						to="/settings#billing"
						className={cn(
							'inline-flex h-8 items-center gap-2 border border-white/10 bg-bg-4/80 px-2.5 text-xs font-medium text-text-primary transition-colors hover:border-accent/50 hover:bg-accent/10',
							isLow && 'border-amber-500/45 text-amber-200',
							error && 'border-destructive/40 text-destructive',
						)}
						aria-label="View credit balance"
					>
						{error ? (
							<AlertCircle className="h-3.5 w-3.5" />
						) : (
							<Wallet className="h-3.5 w-3.5" />
						)}
						<span className="hidden sm:inline">Credits</span>
						<span className="tabular-nums">
							{loading ? '...' : formatCredits(balance)}
						</span>
					</Link>
				</TooltipTrigger>
				<TooltipContent side="bottom" align="end">
					<div className="space-y-1 text-xs">
						<p className="font-medium">{walletLabel}</p>
						{error ? (
							<p>{error}</p>
						) : (
							<>
								<p>{formatCredits(balance)} credits available</p>
								<p>Generations use actual model token costs</p>
							</>
						)}
					</div>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
